import styled from "styled-components";


export const LiTitles = styled.li`
    display:flex;   
    width: 100%;
    justify-content: space-between;
    >div:first-child{
        width: 25%;
    }
    >div:not(:first-child){
        width: 16.66666667%;
        padding: 0;
        font-weight: 700;
        font-size: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align:center;
        white-space: pre-line;
    }
    @media(max-width: 960px){
        display: none;
    }
`;

export const LiPanelBodyContent = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;

    >div:first-child{
        width: 25%;
        @media(max-width: 960px){
            width: 100%;
            justify-content: flex-start;
        }
    }
    >div:not(:first-child){
        width: 16.66666667%;
        padding: 0;
        font-weight: 700;
        font-size: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align:center;
        white-space: pre-line;
        @media(max-width: 960px){
            width: 100%;
            justify-content: flex-start;
        }
    }

    @media(max-width: 960px){
        flex-direction: column;
    }

    ${(props) => props.hidden ? "display: none;" : ""}
`;
